import React, { PureComponent } from 'react';
import styles from './index.css';
import { WxLaunchApp } from '../../wxLaunchApp';
class SimpleGuideLayer extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isShowGuideLayer: this.props.isShowGuideLayer
        };
        this.closeGuideFn = () => {
            this.props.closeGuideFn();
        };
        this.gotoClientFn = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
            this.props.gotoClientFn(isSendCount, isJumpQQlink, isCallApp);
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.isShowGuideLayer !== state.isShowGuideLayer) {
            return {
                isShowGuideLayer: props.isShowGuideLayer,
            };
        }
        return null;
    }
    render() {
        const { unfoldType, unfoldTextInfo, wxLaunchSwitch, schemeLink, wxLaunchType } = this.props;
        const { isShowGuideLayer } = this.state;
        const layerTitle = unfoldTextInfo.title || '当前内容仅限端内浏览';
        const layerSubTitle = unfoldTextInfo.subtitle || '进入凤凰新闻客户端，免费获取精彩内容';
        const layerButtonText = unfoldTextInfo.buttonText || '立即浏览';
        if (typeof window !== 'undefined') {
            const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            if (isShowGuideLayer) {
                document.body.style.position = 'fixed';
                document.body.style.width = '100%';
                document.body.style.top = `-${scrollTop}px`;
                document.body.style.touchAction = 'none';
            }
            else {
                document.body.style.position = '';
                document.body.style.width = '';
                document.body.style.touchAction = '';
                if (parseInt(document.body.style.top)) {
                    const topVal = (document.body.style.top && parseInt(document.body.style.top.replace('-', ''))) || 0;
                    document.documentElement.scrollTop = document.body.scrollTop = topVal;
                }
                document.body.style.top = '';
            }
        }
        return (isShowGuideLayer && React.createElement(React.Fragment, null,
            unfoldType === '2' && React.createElement("div", { className: styles.guideLayer },
                React.createElement("div", { className: styles.guideLayerBox },
                    React.createElement("p", { className: styles.guideLayerInfo },
                        "\u524D\u5F80\u51E4\u51F0\u65B0\u95FBAPP\u67E5\u770B\u5168\u6587\uFF0C",
                        React.createElement("br", null),
                        "\u4F53\u9A8C\u66F4\u4F73"),
                    React.createElement("div", { className: styles.guideLayerBtn },
                        React.createElement("a", { href: "javascript:void(0);", onClick: this.closeGuideFn, className: styles.guideLayerCancel }, "\u53D6\u6D88"),
                        React.createElement("a", { href: "javascript:void(0);", onClick: this.gotoClientFn.bind(this, true, false, true), className: styles.guideLayerInto },
                            "\u524D\u5F80",
                            wxLaunchSwitch && React.createElement(WxLaunchApp, { launchType: wxLaunchType, schemeLink: schemeLink, launchAppClick: this.gotoClientFn.bind(this, true, false, false), launchAppFail: this.gotoClientFn.bind(this, false, true, true) }))))),
            unfoldType === '3' && React.createElement("div", { className: styles.guideLayer },
                React.createElement("div", { className: styles.guideLayerBox },
                    React.createElement("h2", { className: styles.forbidLayerTitle }, layerTitle),
                    React.createElement("p", { className: styles.forbidLayerSubTitle }, layerSubTitle),
                    React.createElement("a", { className: styles.forbidLayerButton, href: "javascript:;", onClick: this.gotoClientFn.bind(this, true, false, true) },
                        layerButtonText,
                        wxLaunchSwitch && React.createElement(WxLaunchApp, { launchType: wxLaunchType, schemeLink: schemeLink, launchAppClick: this.gotoClientFn.bind(this, true, false, false), launchAppFail: this.gotoClientFn.bind(this, false, true, true) })),
                    React.createElement("a", { className: styles.forbidLayerBoxClose, href: "javascript:;", onClick: this.closeGuideFn })))));
    }
}
export default SimpleGuideLayer;
